module.exports = __webpack_public_path__ + "static/media/reference-slider-9.0521c622.jpg";